import { Purchase } from '@bzbs/react-api-client';
import { campaignType } from '../constant';

export type PurchaseItemInfo = {
  title: string;
  pointPerUnit: number;
  expireDate: Date;
  expiredIn?: number;
  image: string;
  showTracking: boolean;
  showCode: boolean;
  expired: boolean;
  status: PurchaseItemStatus;
};

export type PurchaseItemStatus =
  | 'redeemed'
  | 'used'
  | 'expired'
  | 'draw_win'
  | 'draw_lose'
  | 'draw_waiting'
  | 'prepared_for_shipping'
  | 'shipped';

export function getPurchaseItemStatus(item: Purchase): PurchaseItemInfo {
  const title = item.Name ?? '';
  const pointPerUnit = item.PointPerUnit ?? 0;
  const image = item.FullImageUrl ?? '';
  const showTracking = item.Delivered ?? false;
  const expireDate = new Date((item.VoucherExpireDate ?? 0) * 1000);

  let showCode = false;
  let status: PurchaseItemStatus = 'used';

  if (item.ArrangedDate) {
    return { title, pointPerUnit, expireDate, image, showTracking, showCode: false, expired: false, status: 'used' };
  }

  if (item.IsExpired || (item.ExpireIn && item.ExpireIn <= 0)) {
    return { title, pointPerUnit, expireDate, image, showTracking, showCode: false, expired: true, status: 'expired' };
  }

  if (item.VoucherExpireDate && item.VoucherExpireDate <= Date.now() / 1000) {
    return { title, pointPerUnit, expireDate, image, showTracking, showCode: false, expired: true, status: 'expired' };
  }

  switch (item.Type) {
    case campaignType.free:
    case campaignType.deal:
      status = 'redeemed';
      showCode = true;
      break;
    case campaignType.draw:
      if (item.HasWinner) {
        status = item.IsWinner ? 'draw_win' : 'draw_lose';
      } else {
        status = 'draw_waiting';
      }
      break;
  }

  if (item.Delivered) {
    showCode = false;
    status = item.IsShipped ? 'shipped' : 'prepared_for_shipping';
  }

  return {
    title,
    pointPerUnit,
    expireDate,
    image,
    showTracking,
    showCode,
    expired: false,
    status,
  };
}
